import React from 'react'
import { CircularProgress, InputAdornment } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { ClassesType } from '../types'

const useStyles = makeStyles(
  () => ({
    adornment: {},
    progress: {},
  }),
  { name: 'PuiTextArea' },
)

export interface CircularProgressAdornmentProps {
  readonly circularProgressSize: number | string
  readonly classes?: ClassesType<typeof useStyles>
  readonly position: 'start' | 'end'
}

const CircularProgressAdornment = ({
  classes: classesProp,
  circularProgressSize,
  position,
}: CircularProgressAdornmentProps) => {
  const classes = useStyles({ classes: classesProp })

  return (
    <InputAdornment className={classes.adornment} position={position}>
      <CircularProgress
        className={classes.progress}
        size={circularProgressSize}
      />
    </InputAdornment>
  )
}

export default CircularProgressAdornment
